import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { MicroFrontendResolver } from 'core/resolvers';
import { ReportResolver } from './resolvers/report.resolver';
import { ReportingToolComponent } from './reporting-tool/reporting-tool.component';
import { ReportsComponent } from './reports/reports.component';

const reportsRoutes: Routes = [
  {
    path: 'reports',
    title: 'reports.label',
    data: { microfrontends: ['GlReports'] },
    resolve: {
      glreports: MicroFrontendResolver
    },
    children: [
      {
        path: '',
        title: '',
        component: ReportsComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.menu' }
      },
      {
        path: 'licenses',
        title: 'reports.licenses.label',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.licenses', report: 'licenses' }
      },
      {
        path: 'groups',
        title: 'reports.groups.label',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.groups', report: 'groups' }
      },
      {
        path: 'students',
        title: 'reports.students.label',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.students', report: 'students' }
      },
      {
        path: 'events',
        title: 'reports.events.label',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.events', report: 'events' }
      },
      {
        path: 'activity',
        title: 'reports.activity.label',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.activity', report: 'activity' }
      },
      {
        path: 'surveys',
        title: 'reports.surveys.label',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.surveys', report: 'surveys' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(reportsRoutes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule {}
